import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Ng4FilesModule } from 'angular4-files-upload';
import { segmentsComponent } from './segments/segments.component';
import { segmentsListComponent } from './segments-list/segments-list.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { StatusRoutingModule } from './segments-routing.module';
import { segmentsService } from './segments.service';
import { SharedModule } from '../../shared/shared.module';

//Spinner
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerService } from 'ngx-spinner';
import { segmentsEditComponent } from './segments-edit/segments-edit.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';

import { MatTableModule } from '@angular/material';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { MatIconModule } from "@angular/material/icon";
import { UserService } from '../user/user.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    SharedModule,
    StatusRoutingModule,
    Ng4FilesModule,
    NgSelectModule,
    NgxSpinnerModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatTableModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  declarations: [
    segmentsComponent,
    segmentsListComponent,
    segmentsEditComponent
  ],
  providers: [
    segmentsService,
    NgxSpinnerService,
    UserService
    
  ]
})
export class SegmentsModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/segments/segments.module.ts